export type CustomerManagementView = "active" | "history";

export interface CustomerCompletionRecord {
  customerCompleted: boolean;
}

export function customerManagementViewRecords<T extends CustomerCompletionRecord>(
  records: readonly T[],
  view: CustomerManagementView,
): T[] {
  return records.filter((record) =>
    view === "history" ? record.customerCompleted : !record.customerCompleted
  );
}

export function customerManagementViewCounts(
  records: readonly CustomerCompletionRecord[],
): { active: number; history: number } {
  let history = 0;
  for (const record of records) {
    if (record.customerCompleted) history += 1;
  }
  return { active: records.length - history, history };
}
